<template>
  <div>
    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step :complete="e1 > 1" step="1">
          What is the purpose of your appointment?
        </v-stepper-step>

        <v-divider></v-divider>
        <v-stepper-step :complete="e1 > 2" step="2">
          Select a Date
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 3" step="3">
          Choose your preferred time
        </v-stepper-step>
        <v-stepper-step step="4"> Summary </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-btn color="primary" @click="step1"> Continue </v-btn>

          <div>
            <Purpose @purpose_selected="on_purpose_change" />
          </div>
        </v-stepper-content>
        <v-stepper-content step="2">
          <v-btn color="primary" @click="step2"> Continue </v-btn>
          <v-btn text @click="back(1)"> Back </v-btn>
          <v-card class="mb-12" color="grey lighten-1" height="400px">
            <Calendar @on_selected_date="on_date_selected" />
            <!-- The appointment date: {{the_appointment_date}} -->
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="3">
          <v-btn color="primary" @click="e1 = 4"> Continue </v-btn>
          <v-btn text @click="back(2)"> Back </v-btn>
          <v-card class="mb-12" height="260px">
            <Time @on_selected_time="on_time_selected" />
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="4">
          <v-btn color="primary" @click="end"> Continue </v-btn>
          <v-btn text @click="back(3)"> Cancel </v-btn>
          <v-card height="300px" color="#BDBDBD">
            <Summary :summary_data="note_data" />
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-dialog
      v-model="end_dialog"
      persistent
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <Note :data="note_data" />
    </v-dialog>
  </div>
</template>
<script>
import Purpose from "./screens/Purpose.vue";
import Calendar from "./screens/Calendar.vue";
import Time from "./screens/TimeTable.vue";
import Summary from "./screens/Summary.vue";
import Note from "./screens/Note.vue";

export default {
  data() {
    return {
      end_dialog: false,
      e1: 1,
      // put these in axios
      the_purposes: [],
      the_details: [],
      the_appointment_date: [],
      the_selected_time: "",
      note_data: {
        purposes: [],
        appointment_date: [],
        selected_time: "",
      },
    };
  },
  components: { Note, Purpose, Calendar, Time, Summary },
  methods: {
    back(int) {
      this.e1 = int;
    },
    step1() {
      if (this.the_purposes.length > 0) {
        this.e1 = 2;
      } else {
        alert("Please select the purpose of your request");
      }
    },
    step2() {
      if (this.the_appointment_date.length > 0) {
        this.e1 = 3;
      } else {
        alert("Please select the date");
      }
    },
    end() {
      this.end_dialog = true;
    },
    on_purpose_change(e) {
      // this.the_purposes = e;

      this.note_data.purposes = e;
      this.the_purposes = e.map((s) => s.subject);
      this.the_purposes = [...new Set(this.the_purposes)];
      this.the_purposes = this.the_purposes.filter((x) => x != null);
      this.the_purposes = this.the_purposes.join(",");
      this.note_data.purposes = this.the_purposes;
      this.the_details = e.map((s) => s.title);
      this.the_details = [...new Set(this.the_details)];
      this.the_details = this.the_details.filter((x) => x != null);
      this.the_details = this.the_details.join(",");
      this.note_data.the_details = this.the_details;  
    },
    on_date_selected(e) {
      this.the_appointment_date = e;
      this.note_data.appointment_date = e;
    },
    on_time_selected(e) {
      this.the_selected_time = e;
      this.note_data.selected_time = e;
    },
  },
};
</script>